import { render, staticRenderFns } from "./ListOfResponses.vue?vue&type=template&id=252b79ce&scoped=true"
import script from "./ListOfResponses.vue?vue&type=script&lang=js"
export * from "./ListOfResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b79ce",
  null
  
)

export default component.exports